<template>
  <div>
    <pop-modal ref="popModal" :visible="visible" :isDrag="true" title="领用发票" width="70%" :height="80" @cancel="handelCancel">
      <div class="header">
        <div class="select">
          <div>
            <span class="mr-1">申请时间起</span
            ><a-date-picker v-model="applyParam.startDate" @change="startChange" /><input
              type="checkbox"
              class="ml-1"
              v-model="startChecked"
            />
          </div>
          <div>
            <span class="mr-1">申请时间止</span><a-date-picker v-model="applyParam.endDate" @change="endChange" /><input
              type="checkbox"
              class="ml-1"
              v-model="endChecked"
            />
          </div>
        </div>
        <div class="btn">
          <a-button type="primary" ghost class="mr-1" @click="searchDrawInvoice()"> 查询 </a-button>
          <a-button type="primary" ghost class="mr-1" @click="openInvoiceDownload()"> 发票下载 </a-button>
          <a-button type="primary" ghost class="mr-1" disabled> 手工下载 </a-button>
        </div>
      </div>
      <m-table
        :filterMultiple="true"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="sourceData"
      >
        <template #operation>
          <a-button @click="openOptionModal('detailed')">明细</a-button>
          <a-button @click="applyConfirm()">确认</a-button>
          <a-button @click="applyDismiss()">撤销</a-button>
        </template>
      </m-table>
    </pop-modal>
    <pop-modal :visible="optionShow" :isDrag="true" title="操作" width="800px" :height="67" @cancel="optionShow = false">
      <m-table
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="detailedColumns"
        :data-source="detailedData"
      >
      </m-table>
      <div>
        <a-button @click="onlinePay()">确定</a-button>
      </div>
    </pop-modal>
    <online-apply ref="OnlineApplyForm"></online-apply>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
import OnlineApply from './OnlineApply.vue'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  components: {
    OnlineApply,
  },
  data() {
    return {
      visible: false,
      pagination: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '发票种类',
          dataIndex: 'taxClass',
          width: 100,
          customRender: (v) => (v === 0 ? '增值税专用发票' : v === 1 ? '增值税普通发票' : '电子普通发票'),
        },
        {
          title: '发票代码',
          dataIndex: 'taxBillBuyNum',
          width: 100,
        },
        {
          title: '起始号码',
          dataIndex: '',
          width: 100,
          customRender: (v) => (v === 0 ? '申领待确认' : v === 1 ? '网上申领成功' : '申领已撤销'),
        },
        {
          title: '发票张数',
          dataIndex: '',
          width: 100,
        },
      ],
      sourceData: [],
      applyParam: {
        taxClass: '',
        status: '',
        startDate: moment(),
        endDate: moment(),
      },
      startChecked: false,
      endChecked: false,
      // 操作弹窗
      optionShow: false,
      detailedColumns: [
        {
          title: '发票种类',
          dataIndex: 'a',
        },
        {
          title: '开票限额',
          dataIndex: 'b',
        },
        {
          title: '类别代码',
          dataIndex: 'c',
        },
        {
          title: '类别名称',
          dataIndex: 'd',
        },
        {
          title: '起始号码',
          dataIndex: 'd',
        },
        {
          title: '发票张数',
          dataIndex: 'd',
        },
      ],
      detailedData: [
        {
          a: '0',
          b: '9',
          c: '1998',
          d: '1998',
        },
      ],
    }
  },
  methods: {
    show() {
      this.visible = true
      this.searchDrawInvoice()
    },
    handelCancel() {
      this.visible = false
    },
    /**
     * 网上购票查询
     */
    async searchDrawInvoice() {
      const params = parseParam()
      const res = await this.$http.post(`${Urls.drawInvoiceList}&${params}`)
      if (res) {
        this.sourceData = res.data
      }
    },
    startChange(date, dateString) {
      this.applyParam.startDate = date
    },
    endChange(date, dateString) {
      this.applyParam.endDate = date
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 申领确认
    async applyConfirm() {
      const params = parseParam({
        id: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.post(`${Urls.applyConfirm}&${params}`)
      if (res) {
        this.$success({
          title: '提示',
          content: '申领成功',
        })
        this.searchDrawInvoice()
      }
    },
    // 申领撤销
    async applyDismiss() {
      const params = parseParam({
        id: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.post(`${Urls.applyDismiss}&${params}`)
      if (res) {
        this.$success({
          title: '提示',
          content: '撤销成功',
        })
        this.searchDrawInvoice()
      }
    },
    // 弹窗
    openInvoiceDownload() {
      if (this.selectedRowKeys.length === 0) {
        this.$error({
          title: '警告',
          content: '至少选中一条记录',
        })
        return
      }
      this.optionShow = true
    },
    // 网上领票确认
    async onlinePay() {
      const ids = this.selectedRowKeys.reduce((pre, cur) => {
        return cur.id + pre
      }, '')
      const params = parseParam({
        ids: ids,
      })
      const res = await this.$http.post(`${Urls.onLinePayInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.optionShow = false
        this.handelCancel()
        this.$success({
          title: '提示',
          content: '发票已导入金税盘!',
        })
      } else {
        this.$error({
          title: '警告',
          content: res.msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  .select {
    display: flex;
    flex: 1;
    justify-content: space-around;
    > div {
      display: flex;
      margin-right: 10px;
      align-items: center;
      > div {
        padding: 10px 0;
      }
    }
  }
  .btn {
    justify-content: space-between;
  }
}
</style>
